export default "__VITE_ASSET__CK6y$5pB__"